import React from 'react';
import { motion } from 'framer-motion';
export function Testimonial() {
  return <section className="py-32 bg-[#0A192F] relative overflow-hidden flex items-center justify-center" data-id="element-113">
      {/* Decorative Quote Mark */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-[300px] font-serif text-[#1D3461] opacity-30 pointer-events-none leading-none" data-id="element-114">
        "
      </div>

      <div className="max-w-4xl mx-auto px-6 relative z-10 text-center" data-id="element-115">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-116">
          <p className="text-3xl md:text-5xl font-['Playfair_Display'] italic text-[#FFF8F0] leading-snug md:leading-normal mb-8" data-id="element-117">
            "El budismo no te pide escapar del mundo. Te invita a vivir en él
            con más presencia."
          </p>
          <div className="w-16 h-[1px] bg-[#D4AF37] mx-auto mb-6" data-id="element-118"></div>
          <p className="text-[#A8B2D1] font-['Inter'] tracking-widest uppercase text-sm" data-id="element-119">
            Budismo para la Vida Moderna
          </p>
        </motion.div>
      </div>
    </section>;
}